import type { SlideProps } from "@/engine/app/offsite-config";

const ROWS = [
  { mythos: "KI ersetzt Menschen", realitaet: "KI entlastet – ihr entscheidet weiter" },
  { mythos: "KI ist eine Blackbox", realitaet: "Jeder Schritt nachvollziehbar und geloggt" },
  {
    mythos: "KI macht keine Fehler",
    realitaet: "KI macht Fehler – mit Sicherheitsnetz fangen wir sie",
  },
  {
    mythos: "KI braucht alle Daten",
    realitaet: "KI nutzt nur freigegebene Daten im Firmenkontext",
  },
];

export function Slide21MythosRealitaet(_: SlideProps) {
  return (
    <div className="deck-root dark" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1">Mythos / Realität</div>
        <h1 className="deck-title rise rise-2">
          Was KI <br />
          <span className="accent">nicht ist</span>
        </h1>
      </header>

      <div className="status-grid rise rise-4">
        <div className="status-headers">
          <div className="neg">Mythos</div>
          <div className="pos">Realität</div>
        </div>
        {ROWS.map((r) => (
          <div key={r.mythos} className="status-row">
            <div className="status-cell neg">
              <span className="status-mark neg">✕</span>
              <span className="status-text">{r.mythos}</span>
            </div>
            <div className="status-cell pos">
              <span className="status-mark pos">✓</span>
              <span className="status-text">{r.realitaet}</span>
            </div>
          </div>
        ))}
      </div>

      <footer className="deck-foot">
        <span>Transparenz ist keine Option – Transparenz ist Pflicht.</span>
      </footer>
    </div>
  );
}
